<template>
  <div class="pages">
    <div id="taskInfo">
      <!-- 水印 -->
      <div class="watermask" v-if="watermask && watermask.info">
        <div class="waterinfo">
          <div class="watertext1">{{ watermask.info }}</div>
          <div>{{ watermask.time }}</div>
          <div>{{ watermask.remark }}</div>
        </div>
        <div class="waterinfo">
          <div class="watertext1">{{ watermask.info }}</div>
          <div>{{ watermask.time }}</div>
          <div>{{ watermask.remark }}</div>
        </div>
      </div>
      <van-image class="status_icon" :src="Util.getImgUrl('static/images/task/status/ok2.png')"
        v-if="task && task.task_status == 'pass'" />


      <!-- 表单内容 -->
      <div class= "field_cell_box" v-for="field in fields" :key="field" v-show="field.field_required || field.field_value !== ''">
        <taskField :field.sync="field"></taskField>
      </div>

      <!-- 审批流程 -->
      <div class="node_block">
        <div v-for="(node, node_index) in reviews" :key="node.review_id">
          <div class="node_cell">
            <div class="node_left">
              <div class="line_circle" :class="{ 'line_circle_current': node.review_id }"></div>
              <div class="line_line" :class="{ 'line_line_current': node.review_id }"
                v-if="node_index < reviews.length - 1">
              </div>
            </div>
            <div class="node_right" v-if="node.review_id">
              <div class="node_name">
                <div class="flex1">{{ node.workflow_link_name }}</div>
                <div :class="{ 'yes_text': node.is_yes, 'no_text': !node.is_yes }">{{ node.action_name }}</div>
              </div>
              <div class="node_users">
                <div class="user_cell" v-for="user in node.node_users" :key="user.uid">
                  <van-image round v-if="user.avatar" class="avatar" :src="Util.getImgUrl(user.avatar)">{{ user.realname
                  }}
                  </van-image>
                  <div v-else class="avatar_name">{{ Util.miniName(user.realname) }}</div>
                  <div class="realname">{{ user.realname }}</div>
                </div>
                <div class="node_review">
                  <div v-if="node.pre_node_id == 0">{{ node.workflow_link_name }}{{ node.action_name }}</div>
                  <div v-else-if="node.pre_node_id == -2">{{ node.review_msg }}</div>
                  <div v-else>审批意见：{{ node.review_msg }}</div>

                  <div class="file_flex">
                    <div class="file_cell" v-for="(file, file_index) in node.upload_attachments" :key="file.file_id"
                      @click="onOpenFile(file, file_index)">
                      <van-image fit="cover" class="file_icon"
                        :src="Util.getImgUrl(file.type == 'image' ? file.thumb_src : file.icon)" mode="aspectFill" />
                    </div>
                  </div>
                  <div>{{ node.created_at }}</div>
                </div>
              </div>
              <div class="node_field_box" v-if="node.sub_fields">
                <div class="sub_name">{{ node.sub.sub_name }}</div>
                <div class="sub_field_cell_box" v-for="field in node.sub_fields" :key="field.field_id" v-show="field.field_required || field.field_value !== ''">
                  <taskField :field.sync="field"></taskField>
                </div>
              </div>
            </div>
            <div class="node_right" v-else>
              <div class="node_name">
                <div class="flex1">{{ node.workflow_link_name }}</div>
                <div class="pending_text">{{ node.action_name }}</div>
              </div>
              <div class="node_users">
                <template v-if="node.node_users">
                  <div class="user_cell" v-for="user in node.node_users" :key="user.uid">
                    <van-image round v-if="user.avatar" class="avatar" :src="Util.getImgUrl(user.avatar)">{{
                      user.realname
                    }}
                    </van-image>
                    <div v-else class="avatar_name">{{ Util.miniName(user.realname) }}</div>
                    <div class="realname">{{ user.realname }}</div>
                  </div>
                </template>
                <template v-else>
                  <div class="add_cell" v-if="node.review_self && can_edit">
                    <van-image>加号</van-image>
                  </div>
                </template>
                <div v-if="node.node_error" class="node_error">{{ node.node_error }}</div>
              </div>
            </div>
          </div>
          <div class="node_cell" v-if="node.copy_users">
            <div class="node_left">
              <div class="line_line" :class="{ 'line_line_current': node.review_id }"
                v-if="node_index < reviews.length - 1">
              </div>
            </div>
            <div class="node_right">
              <div class="node_name">
                <div>抄送人</div>
              </div>
              <div class="node_users">
                <div class="user_cell" v-for="user in node.copy_users" :key="user.uid">
                  <van-image round v-if="user.avatar" class="avatar" :src="Util.getImgUrl(user.avatar)">{{ user.realname
                  }}
                  </van-image>
                  <div v-else class="avatar_name">{{ Util.miniName(user.realname) }}</div>
                  <div class="realname">{{ user.realname }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 评论 -->
      <div class="comment_block" v-if="comments && comments.length">
        <div class="comment_top">评论</div>
        <div class="comment_list">
          <div class="comment_item" v-for="comment in comments" :key="comment.comment_id">
            <van-image round class="comment_avatar" :src="Util.getImgUrl(comment.avatar)"></van-image>
            <div class="comment_right">
              <div class="comment_realname">{{ comment.realname }}</div>
              <div class="comment_content">{{ comment.task_comment }}</div>
              <div class="comment_at">{{ comment.created_at }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-overlay :show="overlay_show">
      <div class="overlay_wrapper" @click.stop>
        <div class="overlay_block">
          <van-loading size="44px" vertical color="#1daefe"><span class="overlay_msg">{{ overlay_msg }}</span>
          </van-loading>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import taskField from '../../components/taskField.vue'
import html2canvas from 'html2canvas';
import wx from 'weixin-js-sdk'


export default {
  components: {
    taskField,
  },
  data() {
    return {
      task_id: null,
      watermask: null,
      task: null,
      fields: null,
      reviews: null,
      comments: null,
      overlay_show: false,
      capture_img: '',
      overlay_msg: '加载数据...',
    }
  },
  mounted() {
    let that = this
    that.task_id = that.$route.params.id
    that.t_stamp = that.$route.query.t
    that.overlay_show = true
    that.loadData()
  },
  methods: {
    loadData() {
      let that = this
      that.$api.taskInfo({
        task_id: that.task_id
      }).then(res => {
        document.title = '中船eLink';
        that.watermask = res.data.watermask
        that.task = res.data.task
        that.fields = res.data.fields
        that.reviews = res.data.reviews
        that.comments = res.data.comments

        that.overlay_msg = '渲染页面...'
        setTimeout(() => {
          that.html2canvas()
        }, 3000);
      })
    },
    html2canvas() {
      let that = this
      let height = document.getElementById('taskInfo').scrollHeight
      html2canvas(document.getElementById('taskInfo'), {
        logging: false,
        windowHeight: height,
        useCORS: true,
        // scale: 1
      }).then(function (canvas) {
        that.overlay_msg = '生成图片...'
        that.$api.taskCapture({
          task_id: that.task_id,
          img_data: canvas.toDataURL("image/png"),
        }).then(res => {
          that.capture_img = res.data.url
          console.log(that.capture_img)
          wx.miniProgram.redirectTo({
            url: '/pages/home/downloadImage/downloadImage?type=task&task_id=' + that.task_id + '&img_url=' + that.capture_img
          })
          // wx.previewImage({
          //   current: that.capture_img, // 当前显示图片的 http 链接
          //   urls: [that.capture_img] // 需要预览的图片 http 链接列表
          // });
        })
      });
    },
  }
}
</script>
<style scoped src="./detail.css"></style>
  